import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';

/** Owner/Admin only — the backend returns `403` for other roles. */
export function useTimeOffPolicy() {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useQuery({
    queryKey: TIME_OFF_KEYS.policy(orgId),
    queryFn: ({ signal }) => timeOffService.getPolicy(signal),
    staleTime: 300_000,
    enabled: !!orgId,
  });
}
